export const Menu = [
  {
    name: "Home",
    routerLink: "#/",
  },
  {
    name: "Reclamar pelo WhatsApp",
    routerLink: "https://api.whatsapp.com/send?phone=5521971160297&text=%2APrezado%20Consumidor%2C%20preencha%20os%20dados%20abaixo%20para%20Reclamar%2A%20%F0%9F%93%A2%20%0ASeu%20nome%3A%0ASua%20Cidade%3A%0AEmpresa%20Reclamada%3A%0ASua%20Reclama%C3%A7%C3%A3o%F0%9F%93%A3%3A",
  },
  {
    name: "Quem somos",
    routerLink: "#/quem-somos",
  },
  {
    name: "Como funciona",
    routerLink: "#/",
  },
  {
    name: "Contato",
    routerLink: "#/contato",
  },
];

export const MenuService = [
  {
    id: "43a2b0ee-68d0-4f56-9b57-10e251cb1241",
    name: "contato@reclamerio.com.br",
    routerLink: "mailto:contato@reclamerio.com.br",
    icon: "si si-envelope",
  },
  // {
  //   id: "7c939ae3-05d2-4f76-8e85-bc13595b7f54",
  //   name: "Horário de segunda a sexta Das 9hs ás 18hs",
  //   routerLink: "mailto:contato@reclamerio.com.br",
  //   icon: "si si-clock",
  // },
]

export const MenuUser = [
  {
    name: "Reclamar",
    routerLink: "#/reclamar",
    icon: "fa fa-exclamation mr-2",
  },
  {
    name: "Perfil",
    routerLink: "#/perfil",
    icon: "si si-user mr-2",
  },
]

export const MenuCommercial = [
  {
    name: "Dashboard",
    routerLink: "#/comercial/reclamacoes",
    icon: "fa fa-exclamation mr-2",
  },
  {
    name: "Reclamações",
    routerLink: "#/comercial/empresa",
    icon: "far fa-building mr-2",
  },
  {
    name: "Perfil",
    routerLink: "#/perfil",
    icon: "si si-user mr-2",
  },
]

export const MenuAdmin = [
  {
    name: "Dashboard",
    routerLink: "#/administrator/dashboard",
    icon: "si si-chart",
  },
  {
    name: "Ver reclamações",
    routerLink: "#/administrator/reclamacoes",
    icon: "fa fa-exclamation mr-2",
  },
  {
    name: "Ver serviços",
    routerLink: "#/administrator/servicos",
    icon: "fa fa-list mr-2",
  },
  {
    name: "Empresas",
    routerLink: "#/administrator/empresas",
    icon: "far fa-building mr-2",
  },
  {
    name: "Usuários",
    routerLink: "#/administrator/users",
    icon: "si si-users mr-2",
  },
  // {
  //   name: "Configurações",
  //   routerLink: "#/administrator/settings",
  //   icon: "si si-settings mr-2",
  // },
  // {
  //   name: "Perfil",
  //   routerLink: "#/perfil",
  //   icon: "si si-user mr-2",
  // },
];